import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { db, storage } from './firebase';
import './EditProduct.css';

function EditProduct({ producto, onClose, onUpdate }) {
  const [formData, setFormData] = useState({
    marca: producto.marca,
    modelo: producto.modelo,
    precio: producto.precio,
    estado: producto.estado,
    almacenamiento: producto.almacenamiento,
    color: producto.color,
    cantidad: producto.cantidad || 0,
    descripcion: producto.descripcion
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.marca || !formData.modelo || !formData.precio || !formData.color) {
      setError('Por favor completa todos los campos obligatorios');
      return;
    }

    setLoading(true);

    try {
      const productoRef = doc(db, 'productos', producto.id);
      await updateDoc(productoRef, {
        marca: formData.marca,
        modelo: formData.modelo,
        precio: parseFloat(formData.precio),
        estado: formData.estado,
        almacenamiento: formData.almacenamiento,
        color: formData.color,
        cantidad: parseInt(formData.cantidad),
        descripcion: formData.descripcion,
        updatedAt: new Date()
      });

      alert('✅ Producto actualizado exitosamente');
      if (onUpdate) onUpdate();
      onClose();
    } catch (err) {
      console.error('Error:', err);
      setError('Error al actualizar producto: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content edit-product-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>✏️ Editar Producto</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-section">
            <h3>📱 Información del Producto</h3>
            
            <div className="form-row">
              <div className="form-group">
                <label>Marca *</label>
                <input
                  type="text"
                  name="marca"
                  value={formData.marca}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Modelo *</label>
                <input
                  type="text"
                  name="modelo"
                  value={formData.modelo}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Precio (HNL) *</label>
                <input
                  type="number"
                  name="precio"
                  value={formData.precio}
                  onChange={handleInputChange}
                  step="0.01"
                  required
                />
              </div>

              <div className="form-group">
                <label>Cantidad *</label>
                <input
                  type="number"
                  name="cantidad"
                  value={formData.cantidad}
                  onChange={handleInputChange}
                  min="0"
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Estado</label>
                <select name="estado" value={formData.estado} onChange={handleInputChange}>
                  <option value="Nuevo">Nuevo</option>
                  <option value="Seminuevo">Seminuevo</option>
                  <option value="Usado">Usado</option>
                  <option value="Refurbished">Refurbished</option>
                </select>
              </div>

              <div className="form-group">
                <label>Almacenamiento</label>
                <select name="almacenamiento" value={formData.almacenamiento} onChange={handleInputChange}>
                  <option value="32GB">32GB</option>
                  <option value="64GB">64GB</option>
                  <option value="128GB">128GB</option>
                  <option value="256GB">256GB</option>
                  <option value="512GB">512GB</option>
                  <option value="1TB">1TB</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label>Color *</label>
              <input
                type="text"
                name="color"
                value={formData.color}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Descripción</label>
              <textarea
                name="descripcion"
                value={formData.descripcion}
                onChange={handleInputChange}
                rows="4"
              />
            </div>
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="form-actions">
            <button type="button" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? 'Guardando...' : '✅ Guardar Cambios'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditProduct;